"use client";

import {
    DeviceMobile,
    Desktop,
    Code,
    ShieldCheck,
    Rocket,
    Layout,
    PencilSimple,
    Check
} from "@/app/components/Icons/Phosphoricons"; // ✅ Updated import

import GetStartedButton from "@/app/components/Utils/GetStartedButton";
import React from "react";

export default function CustomApplicationsApps() {
    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                {/* Hero Section with Split Layout */}
                <div className="mb-20">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div className="order-2 lg:order-1">
                            <span className="inline-flex items-center rounded-md bg-blue-100 px-3 py-1 text-sm font-medium text-blue-800 font-system">
                                Cross-Platform Solutions
                            </span>
                            <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl font-system">
                                Custom Mobile & Desktop Applications
                            </h2>
                            <p className="mt-6 text-lg leading-8 text-gray-600 font-system">
                                Transform your business with tailor-made applications that deliver exceptional performance and user experience across all devices.
                            </p>
                            <div className="mt-10">
                                <GetStartedButton />
                            </div>
                        </div>

                        <div className="order-1 lg:order-2 grid grid-cols-2 gap-4">
                            <div className="bg-blue-700 rounded-tl-2xl rounded-br-2xl p-6 text-center flex flex-col items-center justify-center">
                                <DeviceMobile className="h-12 w-12 text-white mb-3" weight="fill" />
                                <div className="text-xl font-bold text-white mb-1 font-system">Mobile Apps</div>
                                <div className="text-sm text-white font-system">iOS & Android</div>
                            </div>
                            <div className="bg-blue-600 rounded-tr-2xl rounded-bl-2xl p-6 text-center flex flex-col items-center justify-center">
                                <Desktop className="h-12 w-12 text-white mb-3" weight="fill" />
                                <div className="text-xl font-bold text-white mb-1 font-system">Desktop Apps</div>
                                <div className="text-sm text-white font-system">Windows, Mac & Linux</div>
                            </div>
                            <div className="bg-blue-600 rounded-tl-2xl rounded-br-2xl p-6 text-center flex flex-col items-center justify-center">
                                <Layout className="h-12 w-12 text-white mb-3" weight="fill" />
                                <div className="text-xl font-bold text-white mb-1 font-system">UX/UI Design</div>
                                <div className="text-sm text-white font-system">Beautiful & Functional</div>
                            </div>
                            <div className="bg-blue-700 rounded-tr-2xl rounded-bl-2xl p-6 text-center flex flex-col items-center justify-center">
                                <Code className="h-12 w-12 text-white mb-3" weight="fill" />
                                <div className="text-xl font-bold text-white mb-1 font-system">Custom Code</div>
                                <div className="text-sm text-white font-system">Tailored Solutions</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Our Approach Section */}
                <div className="mb-24">
                    <div className="text-center mb-12">
                        <h3 className="text-2xl font-semibold text-gray-900 font-system">
                            Our Development Approach
                        </h3>
                        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto font-system">
                            We combine cutting edge technologies with best practices to deliver applications that exceed expectations
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div className="bg-blue-50 rounded-xl p-8 relative overflow-hidden">
                            <div className="relative z-10">
                                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center mb-6">
                                    <PencilSimple className="h-8 w-8 text-blue-600" weight="fill" />
                                </div>
                                <div className="text-blue-600 text-2xl font-semibold mb-1 font-system">01</div>
                                <h4 className="text-lg font-semibold text-gray-900 mb-3 font-system">
                                    Design First
                                </h4>
                                <p className="text-gray-600 font-system">
                                    We begin with an in depth discovery process to understand your users, business goals, and technical requirements.
                                </p>
                            </div>
                            <div className="absolute bottom-0 right-0 opacity-10">
                                <PencilSimple className="h-32 w-32 text-blue-600" weight="fill" />
                            </div>
                        </div>

                        <div className="bg-blue-50 rounded-xl p-8 relative overflow-hidden">
                            <div className="relative z-10">
                                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center mb-6">
                                    <Code className="h-8 w-8 text-blue-600" weight="fill" />
                                </div>
                                <div className="text-blue-600 text-2xl font-semibold mb-1 font-system">02</div>
                                <h4 className="text-lg font-semibold text-gray-900 mb-3 font-system">
                                    Agile Development
                                </h4>
                                <p className="text-gray-600 font-system">
                                    Our iterative approach delivers working software early and often, allowing for continuous feedback and refinement.
                                </p>
                            </div>
                            <div className="absolute bottom-0 right-0 opacity-10">
                                <Code className="h-32 w-32 text-blue-600" weight="fill" />
                            </div>
                        </div>

                        <div className="bg-blue-50 rounded-xl p-8 relative overflow-hidden">
                            <div className="relative z-10">
                                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center mb-6">
                                    <ShieldCheck className="h-8 w-8 text-blue-600" weight="fill" />
                                </div>
                                <div className="text-blue-600 text-2xl font-semibold mb-1 font-system">03</div>
                                <h4 className="text-lg font-semibold text-gray-900 mb-3 font-system">
                                    Quality Assurance
                                </h4>
                                <p className="text-gray-600 font-system">
                                    Rigorous testing throughout the development lifecycle ensures a polished, bug free final product.
                                </p>
                            </div>
                            <div className="absolute bottom-0 right-0 opacity-10">
                                <ShieldCheck className="h-32 w-32 text-blue-600" weight="fill" />
                            </div>
                        </div>

                        <div className="bg-blue-50 rounded-xl p-8 relative overflow-hidden">
                            <div className="relative z-10">
                                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center mb-6">
                                    <Rocket className="h-8 w-8 text-blue-600" weight="fill" />
                                </div>
                                <div className="text-blue-600 text-2xl font-semibold mb-1 font-system">04</div>
                                <h4 className="text-lg font-semibold text-gray-900 mb-3 font-system">
                                    Deployment & Support
                                </h4>
                                <p className="text-gray-600 font-system">
                                    We handle the entire deployment process and provide ongoing maintenance and updates.
                                </p>
                            </div>
                            <div className="absolute bottom-0 right-0 opacity-10">
                                <Rocket className="h-32 w-32 text-blue-600" weight="fill" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Services Section with Alternating Layout */}
                <div className="mb-24">
                    <div className="text-center mb-12">
                        <h3 className="text-2xl font-semibold text-gray-900 font-system">
                            Custom Application Services
                        </h3>
                        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto font-system">
                            Comprehensive solutions for every platform and business need
                        </p>
                    </div>

                    {/* Mobile Applications */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
                        <div className="bg-blue-700 rounded-2xl overflow-hidden">
                            <div className="p-8 text-white">
                                <DeviceMobile className="h-16 w-16 mb-6" weight="fill" />
                                <h4 className="text-xl font-bold mb-4 font-system">Mobile Applications</h4>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>Native iOS apps optimized for iPhone and iPad</span>
                                    </li>
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>Native Android apps for all devices and screen sizes</span>
                                    </li>
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>Cross platform solutions for multiple environments</span>
                                    </li>
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>Mobile web solutions for broader accessibility</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div>
                            <h4 className="text-xl font-bold text-gray-900 mb-4 font-system">Transform Your Mobile Experience</h4>
                            <p className="text-gray-600 mb-6 font-system">
                                Our mobile applications combine stunning design with powerful functionality to deliver exceptional user experiences. Whether you need a consumer facing app or an enterprise solution, we build mobile applications that drive engagement and results.
                            </p>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <div className="font-semibold text-gray-900 mb-1 font-system">Offline Capabilities</div>
                                    <p className="text-sm text-gray-600 font-system">Apps that work with or without internet connection</p>
                                </div>
                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <div className="font-semibold text-gray-900 mb-1 font-system">Device Integration</div>
                                    <p className="text-sm text-gray-600 font-system">Leverage camera, GPS, and other hardware features</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Desktop Applications */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div className="order-2 lg:order-1">
                            <h4 className="text-xl font-bold text-gray-900 mb-4 font-system">Powerful Desktop Solutions</h4>
                            <p className="text-gray-600 mb-6 font-system">
                                Our desktop applications provide the power, performance, and functionality that web applications can't match. We develop custom desktop software that streamlines complex workflows and enhances productivity for your team.
                            </p>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <div className="font-semibold text-gray-900 mb-1 font-system">Hardware Integration</div>
                                    <p className="text-sm text-gray-600 font-system">Connect with specialized equipment and peripherals</p>
                                </div>
                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <div className="font-semibold text-gray-900 mb-1 font-system">Resource Intensive Tasks</div>
                                    <p className="text-sm text-gray-600 font-system">Handle complex calculations and data processing</p>
                                </div>
                            </div>
                        </div>

                        <div className="order-1 lg:order-2 bg-blue-700 rounded-2xl overflow-hidden">
                            <div className="p-8 text-white">
                                <Desktop className="h-16 w-16 mb-6" weight="fill" />
                                <h4 className="text-xl font-bold mb-4 font-system">Desktop Applications</h4>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>Windows applications with native performance</span>
                                    </li>
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>macOS applications with intuitive UI</span>
                                    </li>
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>Linux applications for servers and workstations</span>
                                    </li>
                                    <li className="flex items-start">
                                        <Check className="h-5 w-5 mr-2 mt-0.5" weight="bold" />
                                        <span>Cross-platform desktop apps for all environments</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Technology Stack */}
                <div className="mb-24 bg-gray-50 rounded-2xl p-10">
                    <div className="text-center mb-12">
                        <h3 className="text-2xl font-semibold text-gray-900 font-system">
                            Technology Stack
                        </h3>
                        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto font-system">
                            We use the latest technologies to build high-performance applications
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-white p-6 rounded-xl shadow-sm">
                            <h4 className="font-semibold text-gray-900 mb-4 border-b pb-2 font-system">Mobile Platforms</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">iOS</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Android</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Cross-Platform</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Mobile Web</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Tablet</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Wearables</span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-sm">
                            <h4 className="font-semibold text-gray-900 mb-4 border-b pb-2 font-system">Desktop Platforms</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Windows</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">macOS</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Linux</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Cross-Platform</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Enterprise</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Cloud-Enabled</span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-sm">
                            <h4 className="font-semibold text-gray-900 mb-4 border-b pb-2 font-system">Application Features</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Offline Mode</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Cloud Sync</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Data Encryption</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Push Notifications</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Analytics</span>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-3 text-center">
                                    <span className="text-sm font-medium text-blue-700">Accessibility</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Call to action */}
                <div className="mx-auto max-w-5xl rounded-3xl bg-gradient-to-r from-blue-700 to-blue-900 p-8 text-center sm:p-12">
                    <h3 className="text-2xl font-semibold tracking-tight text-white font-system">
                        Ready to build your custom application?
                    </h3>
                    <p className="mt-4 text-lg text-white font-system">
                        Let's discuss how we can transform your business with tailored mobile and desktop solutions.
                    </p>
                    <div className="mt-8 flex justify-center">
                        <GetStartedButton />
                    </div>
                </div>
            </div>
        </div>
    );
}